export default "__VITE_ASSET__53922680__"